import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VisaService {

  visaApiurl = `${environment.travel}/visas`
  _travelapiUrl = `${environment.travel}`
  

  constructor(
    private _http: HttpClient
  ) { }

  // Visa application functions go here...
  getVisa(visaId:any):Observable<any>{
    return this._http.get<any>(`${this.visaApiurl}/visa/${visaId}`);
  }

  deleteVisa(visaId:any):Observable<any>{
    return this._http.delete<any>(`${this.visaApiurl}/visa/${visaId}`);
  }

  addVisaLeadInformation(formData: any):Observable<any>{
    return this._http.post<any>(`${this.visaApiurl}/addleadinformation`, formData);
  }

  addVisaDocumentCollection(formData: any):Observable<any>{
    return this._http.post<any>(`${this.visaApiurl}/addvisadocuments`, formData);
  }

  uploadDocumentForVisaPassenger(formData: any):Observable<any>{
    return this._http.post<any>(`${environment.travel}/visa/uploadimage`, formData);
  }

  addVisaImportantInformation(formData: any):Observable<any>{
    return this._http.post<any>(`${this.visaApiurl}/addvisaimportantinformation`, formData);
  }

  getAllVisa(pageNumber: any, pageSize:any, token:any, searchKeyword: string, filters : any):Observable<any>{
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize || 10,
      search: searchKeyword || "",
      filters: filters
    }
    return this._http.post<any>(`${this.visaApiurl}`, paginationSettings);
  }

  getAllVisaForLead(leadId: string, pageNumber: any, pageSize:any):Observable<any>{
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize || 10
    }
    return this._http.post<any>(`${this.visaApiurl}/${leadId}`, paginationSettings);
  }

  getCountryDetailsForVisaLead(data:any):Observable<any>{
    return this._http.post<any>(`${environment.travel}/getcountrydetails`, data);
  }

  performBulkActions(req:any): Observable<any>{
    return this._http.put<any>(`${this._travelapiUrl}/updatevisas`, req)
  }
}
